import { BasicTagSwap } from "./BasicTagSwap";

export const headingToBlockTransform = new BasicTagSwap("p");
